
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsff5cfe5004b06fe389a3d9b11b0676cben from './en.yaml'
            i18n.addResourceBundle('en', 'ff5cfe5004b06fe389a3d9b11b0676cb', flattenObject(nsff5cfe5004b06fe389a3d9b11b0676cben), true, true);
        
        export default 'ff5cfe5004b06fe389a3d9b11b0676cb';
    